import { inject, provide, Ref } from "vue";
import { Preview } from "@fresh8/types/src/preview";

export const previewSymbol = Symbol("previewSymbol");

export function createPreview(preview: Ref<Preview>) {
  return { preview };
}

export type PreviewContext = ReturnType<typeof createPreview>;

export function providePreview(preview: Ref<Preview>) {
  provide(previewSymbol, createPreview(preview));
}

export function injectPreview() {
  return inject<PreviewContext>(previewSymbol);
}
